import React from 'react'
import { Text } from 'react-native'
import { useTheme } from 'react-native-paper'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { commonColors } from '@linqpal/common-frontend/src/theme'

/**
 * Text for use in Table
 *
 * @param fontWeight
 * @param width
 * @param style
 * @param content
 * @param children
 * @param props
 * @param {'400'| '500'} props.fontWeight
 * @param { number } props.width
 * @param props.style
 * @returns {JSX.Element}
 * @constructor
 */
export const TextTable = ({
  fontWeight = '500',
  width,
  style,
  content,
  children,
  testID = 'textTable',
  numberOfLines,
  ellipsizeMode,
  ...props
}: {
  fontWeight?: string
  width?: number
  style?: any
  content?: any
  children?: any
  testID?: string
  numberOfLines?: number
  ellipsizeMode?: 'head' | 'middle' | 'tail' | 'clip'
  props?: any
}) => {
  const { fontSizes } = useTheme() as any

  return (
    <Text
      style={composeStyle(
        {
          fontSize: fontSizes.regular,
          lineHeight: fontSizes.medium,
          color: commonColors.primary,
          fontWeight,
          width,
        },
        style,
      )}
      testID={testID}
      numberOfLines={numberOfLines}
      ellipsizeMode={ellipsizeMode}
      {...props}
    >
      {children}
    </Text>
  )
}
